import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import AuthCard from '../../components/auth/AuthCard';
import CheckEmail from '../../components/auth/CheckEmail';
import { AuthService } from '../../service/AuthService';
import { useNotificationStore } from '../../store/storeNotifications';

type IFormInput = {
  email: string;
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, watch, formState: { errors } } = useForm<IFormInput>();
  const [completed, setCompleted] = useState(false);
  const { setNotification } = useNotificationStore(state => state);

  const onSubmitForgot = async (values: IFormInput) => {
    try {
      await AuthService.forgotPassword(values.email);
      setCompleted(true);
      setNotification({ type: 'success', message: 'Reset link sent successfully' });
    } catch {
      setNotification({ type: 'error', message: 'Something went wrong' });
    }
  };

  return (
    <AuthCard>
      {!completed ? (
        <div className="auth-form">
          <div>
            <h2 className="auth-form__title">
              Forgot your <strong>password?</strong>
            </h2>
            <p className="auth-form__subtitle">
              Enter your email and we'll send you a reset link.
            </p>
          </div>

          <div className="auth-form__field">
            <label className="auth-label">Email</label>
            <input
              type="email"
              {...register('email', {
                required: 'Email is required',
                pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Invalid email address' },
              })}
              placeholder="Enter your email"
              className="auth-input"
            />
            {errors.email && <p className="auth-error">{errors.email.message}</p>}
          </div>

          <button
            type="button"
            onClick={handleSubmit(onSubmitForgot)}
            className="auth-btn-primary"
          >
            Send reset link
          </button>

          <button
            type="button"
            onClick={() => navigate('/')}
            className="auth-btn-link auth-btn-link--md auth-btn-link--grey"
          >
            Return to login page
          </button>
        </div>
      ) : (
        <CheckEmail
          bodyText={`An email has been sent to ${watch('email') || 'your email'}. Please click on the included link to reset your password.`}
          onNavigate={() => navigate('/')}
        />
      )}
    </AuthCard>
  );
};

export default ForgotPassword;
